// ========================================================================================================== PAGE ENTRY
gsap.set(".co-home-section-1-bg-image", { scale: 1.15, opacity: 0, transition: 0 });
gsap.set("sticky-header.header-wrapper", { yPercent: -100, opacity: 0, transition: 0 });
gsap.set(".co-home-section-1-title", { scale: 1.3, y: -40, opacity: 0, transition: 0 });
gsap.set(".co-home-section-1-image", { scale: 1.3, y: 0, opacity: 0, transition: 0 });
gsap.set(".co-home-section-1-buttons", { scale: 1.3, y: 40, opacity: 0, transition: 0 });
let coPageEntryTimeline = gsap.timeline();
coPageEntryTimeline.to(".co-home-section-1-bg-image", {
  duration: 1, ease: "power2.inOut",
  scale: 1, opacity: 1
})
.to(".co-home-section-1-image", {
  duration: 0.75, ease: "power1.inOut",
  scale: 1, y: 0, opacity: 1,
}, "-=0.9")
.to(".co-home-section-1-title", {
  duration: 1, ease: "power2.inOut",
  scale: 1, y: 0, opacity: 1,
}, "-=0.9")
.to(".co-home-section-1-buttons", {
  duration: 1, ease: "power2.inOut",
  scale: 1, y: 0, opacity: 1,
}, "-=0.9")
.to("sticky-header.header-wrapper", {
  duration: 1, ease: "power1.inOut",
  yPercent: 0, opacity: 1
}, "-=0.85")
.add(() => {
    document.querySelector(".co-home-section-1-content").classList.add("co-home-section-1-flickity-buttons-ani");
  }, "-=0.5");
// ========================================================================================================== FLICKITY NEXT PREV CLASSES
// ===================================================== 2 POSITIONS AWAY FROM ACTIVE CLASS
Flickity.createMethods.push('_createPrevNextCells');
Flickity.prototype._createPrevNextCells = function() {
  this.on( 'select', this.setPrevNextCells );
};
Flickity.prototype.setPrevNextCells = function() {
  // Remove classes from previously selected slides
  changeSlideClasses( this.previousSlide, 'remove', 'is-previous' );
  changeSlideClasses( this.nextSlide, 'remove', 'is-next' );
  changeSlideClasses( this.previousPreviousSlide, 'remove', 'is-previous-previous' );
  changeSlideClasses( this.nextNextSlide, 'remove', 'is-next-next' );
  // Calculate indices for previous, next, previous-previous, and next-next slides
  var previousI = fizzyUIUtils.modulo( this.selectedIndex - 1, this.slides.length );
  var nextI = fizzyUIUtils.modulo( this.selectedIndex + 1, this.slides.length );
  var previousPreviousI = fizzyUIUtils.modulo( this.selectedIndex - 2, this.slides.length );
  var nextNextI = fizzyUIUtils.modulo( this.selectedIndex + 2, this.slides.length );
  // Store references to these slides
  this.previousSlide = this.slides[ previousI ];
  this.nextSlide = this.slides[ nextI ];
  this.previousPreviousSlide = this.slides[ previousPreviousI ];
  this.nextNextSlide = this.slides[ nextNextI ];
  // Add classes to the new slides
  changeSlideClasses( this.previousSlide, 'add', 'is-previous' );
  changeSlideClasses( this.nextSlide, 'add', 'is-next' );
  changeSlideClasses( this.previousPreviousSlide, 'add', 'is-previous-previous' );
  changeSlideClasses( this.nextNextSlide, 'add', 'is-next-next' );
};
function changeSlideClasses( slide, method, className ) {
  if ( !slide ) {
    return;
  }
  slide.getCellElements().forEach( function( cellElem ) {
    cellElem.classList[ method ]( className );
  });
}
// ========================================================================================================== SECTION 1
// ===================================================== SCROLLTRIGGER
gsap.set('.co-home-section-1-bg-image-frame-1', { top: "-10%", transition: 0 });
gsap.to('.co-home-section-1-bg-image-frame-1', {
  scrollTrigger: {
    trigger: 'body', endTrigger: '.co-home-section-1', start:'top top', end: "bottom top", scrub: 1
  },
  top: "10%"
});
gsap.set('.co-home-section-1-title-frame-1', { transition: 0 });
gsap.to('.co-home-section-1-title-frame-1', {
  scrollTrigger: {
    trigger: 'body', endTrigger: '.co-home-section-1', start:'top top', end: "bottom top", scrub: 1.1
  },
  y: -20
});
gsap.set('.co-home-section-1-image-frame-1', { transition: 0 });
gsap.to('.co-home-section-1-image-frame-1', {
  scrollTrigger: {
    trigger: 'body', endTrigger: '.co-home-section-1', start:'top top', end: "bottom top", scrub: 1.1
  },
  y: -80, scale: 1.4
});
// ===================================================== FLICKITY
var flkty = new Flickity('.co-home-section-1-carousel', {
  autoPlay: 2500,
  pageDots: false, 
  selectedAttraction: 0.01,
  friction: 0.2,
  wrapAround: true,
  draggable: false,
  on: {
    ready: function() {
    }
  }
});
function getTranslateX(slider) {
  var style = window.getComputedStyle(slider);
  var matrix = new WebKitCSSMatrix(style.transform);
  return matrix.m41;
}
function mirrorTranslateX(translateX, selector, scale = 1) {
  var elements = document.querySelectorAll(selector);
  var scaledTranslateX = translateX * scale;
  elements.forEach(function(element) {
      element.style.transform = `translateX(${scaledTranslateX}px)`;
  });
}
function handleCellTransforms(flkty) {
  flkty.cells.forEach(function(cell) {
      var originalTransform = cell.element.style.transform;
      var translateXMatch = originalTransform.match(/translateX\((-?\d+(\.\d+)?)%\)/);
      if (translateXMatch) {
          var translateXValue = parseFloat(translateXMatch[1]);
          var mirroredTranslateXValue = -translateXValue;
          var childElement1 = cell.element.querySelector('.co-home-section-1-cell-layer-2');
          if (childElement1) {
              childElement1.style.transform = `translateX(${mirroredTranslateXValue}%)`;
          }
          var percentageTranslateXValue = translateXValue * 0.2;
          var childElement2 = cell.element.querySelector('.co-home-section-1-cell-layer-4');
          if (childElement2) {
              childElement2.style.transform = `translateX(${percentageTranslateXValue}%)`;
          }
      }
  });
}
function updateTransforms() {
  var slider = document.querySelector('.flickity-slider');
  var translateX = getTranslateX(slider);
  mirrorTranslateX(translateX, '.co-home-section-1-cell-layer-1', -1);
  mirrorTranslateX(translateX, '.co-home-section-1-cell-layer-3', 0.2);
  handleCellTransforms(flkty);
}
flkty.on('dragMove', updateTransforms);
flkty.on('scroll', updateTransforms);
flkty.on('settle', updateTransforms);
// ========================================================================================================== SECTION 2
// ===================================================== SCROLLTRIGGER
// TRIGGERS
gsap.set('.co-home-section-2-center-frame>div', { opacity: 0, y: 30, transition: 0 });
gsap.set('.co-home-section-2-left', { opacity: 0, x: -20, y: -20, transition: 0 });
gsap.set('.co-home-section-2-right', { opacity: 0, x: 20, y: 20, transition: 0 });
let coHomeSection2Timeline = gsap.timeline({ paused: true });
coHomeSection2Timeline.to(".co-home-section-2-left", {
  duration: 1,
  ease: "power2.inOut",
  x: 0,
  y: 0,
  opacity: 1
});
coHomeSection2Timeline.to(".co-home-section-2-right", {
  duration: 1,
  ease: "power2.inOut",
  x: 0,
  y: 0,
  opacity: 1
}, "-=0.9");
coHomeSection2Timeline.to(".co-home-section-2-center-frame>div", {
  duration: 1,
  ease: "power2.inOut",
  y: 0,
  opacity: 1
}, "-=0.9");
ScrollTrigger.create({
  trigger: '.co-home-section-2-center', start:'25% bottom', end: "bottom top",
  animation: coHomeSection2Timeline
});
// LEFT IMAGE
gsap.set('.co-home-section-2-image-1 ', { transformOrigin: "top left", transition: 0 });
gsap.to('.co-home-section-2-image-1', {
  scrollTrigger: {
    trigger: '.co-home-section-2-center', endTrigger: ".co-home-section-2", start:'top bottom', end: "bottom top", scrub: 1
  },
  scale: 1.2
});
gsap.set('.co-home-section-2-image-1-frame-1 ', { transition: 0 });
gsap.to('.co-home-section-2-image-1-frame-1', {
  scrollTrigger: {
    trigger: '.co-home-section-2-center', endTrigger: ".co-home-section-2", start:'top bottom', end: "bottom top", scrub: 1
  },
  yPercent: 25
});
gsap.set('.co-home-section-2-image-1-frame-2 ', { transition: 0 });
gsap.to('.co-home-section-2-image-1-frame-2', {
  scrollTrigger: {
    trigger: '.co-home-section-2-center', endTrigger: ".co-home-section-2", start:'top bottom', end: "bottom top", scrub: 1
  },
  yPercent: -33.333
});
if (document.querySelector('.co-home-section-2-image-1-img-1')) {
  gsap.set('.co-home-section-2-image-1-img-2', { opacity: 1, transition: 0 });
  gsap.to('.co-home-section-2-image-1-img-2', {
    scrollTrigger: {
      toggleActions: "play none none reverse",
      trigger: '.co-home-section-2-center', endTrigger: ".co-home-section-2", start:'50% 50%', end: "bottom top"
    },
    duration: 0.5,
    opacity: 0
  });
}
// RIGHT IMAGE
gsap.set('.co-home-section-2-image-2 ', { transformOrigin: "bottom right", transition: 0 });
gsap.to('.co-home-section-2-image-2', {
  scrollTrigger: {
    trigger: '.co-home-section-2-center', endTrigger: ".co-home-section-2", start:'top bottom', end: "bottom top", scrub: 1
  },
  scale: 1.2
});
gsap.set('.co-home-section-2-image-2-frame-1 ', { transition: 0 });
gsap.to('.co-home-section-2-image-2-frame-1', {
  scrollTrigger: {
    trigger: '.co-home-section-2-center', endTrigger: ".co-home-section-2", start:'top bottom', end: "bottom top", scrub: 1
  },
  yPercent: -25
});
gsap.set('.co-home-section-2-image-2-frame-2 ', { transition: 0 });
gsap.to('.co-home-section-2-image-2-frame-2', {
  scrollTrigger: {
    trigger: '.co-home-section-2-center', endTrigger: ".co-home-section-2", start:'top bottom', end: "bottom top", scrub: 1
  },
  yPercent: 33.333
});
if (document.querySelector('.co-home-section-2-image-2-img-1')) {
  gsap.set('.co-home-section-2-image-2-img-2', { opacity: 1, transition: 0 });
  gsap.to('.co-home-section-2-image-2-img-2', {
    scrollTrigger: {
      toggleActions: "play none none reverse",
      trigger: '.co-home-section-2-center', endTrigger: ".co-home-section-2", start:'50% 50%', end: "bottom top"
    },
    duration: 0.5,
    opacity: 0
  });
}
// ========================================================================================================== SECTION 3
// ===================================================== FLICKITY
document.addEventListener('DOMContentLoaded', function() {
  const coHomeSection3Sliders = document.querySelectorAll('.co-home-section-3-collection-slider');
  let slidersInitialized = 0;
  const totalSliders = coHomeSection3Sliders.length;
  coHomeSection3Sliders.forEach(function(slider) {
    new Flickity(slider, {
      cellAlign: "center",
      contain: true,
      prevNextButtons: true,
      pageDots: false,
      wrapAround: true,
      selectedAttraction: 0.005,
      friction: 0.15,
      on: {
        ready: function() {
          console.log("Flickity initialized for slider");
          slidersInitialized++;
          if (slidersInitialized === totalSliders) {
            document.dispatchEvent(new Event('flickityInitialized'));
          }
        }
      }
    });
  });
});
// ===================================================== TABS
document.addEventListener('flickityInitialized', function() {
  const thumbnails = document.querySelectorAll('.co-home-section-3-thumbnail-item');
  const collections = document.querySelectorAll('.co-home-section-3-collection-tabs');

  // SLIDER GSAP
  const coHomeSection3Items = [
    document.querySelector('.co-home-section-3-collection-slider .is-previous-previous .co-home-section-3-collection-item-frame-2'),
    document.querySelector('.co-home-section-3-collection-slider .is-previous .co-home-section-3-collection-item-frame-2'),
    document.querySelector('.co-home-section-3-collection-slider .is-selected .co-home-section-3-collection-item-frame-2'),
    document.querySelector('.co-home-section-3-collection-slider .is-next .co-home-section-3-collection-item-frame-2'),
    document.querySelector('.co-home-section-3-collection-slider .is-next-next .co-home-section-3-collection-item-frame-2')
  ].filter(item => item !== null);

  gsap.set('.co-home-section-3-main-title-frame', { opacity: 0, y: 30, transition: 0 });
  gsap.set('.co-home-section-3-thumbnail-items-wrapper', { opacity: 0, y: 30, transition: 0 });
  gsap.set('.co-home-section-3-main-button', { opacity: 0, y: 30, transition: 0 });
  gsap.set('.co-home-section-3-collection-tabs-wrapper', { opacity: 0, transition: 0 });
    
  let coHomeSection3Timeline = gsap.timeline({ paused: true });
  coHomeSection3Timeline.to(".co-home-section-3-collection-tabs-wrapper", {
    duration: 0.3,
    opacity: 1
  });
  coHomeSection3Timeline.to(".co-home-section-3-main-title-frame", {
    duration: 1,
    ease: "power2.inOut",
    y: 0,
    opacity: 1
  }, "-=0.3");
  coHomeSection3Timeline.to(".co-home-section-3-thumbnail-items-wrapper", {
    duration: 1,
    ease: "power2.inOut",
    y: 0,
    opacity: 1
  }, "-=0.9");
  coHomeSection3Timeline.fromTo(coHomeSection3Items, { opacity: 0, yPercent: 0, xPercent: 20 }, { opacity: 1, yPercent: 0, xPercent: 0, stagger: 0.1, duration: 1 }, "-=0.6");
  coHomeSection3Timeline.to(".co-home-section-3-main-button", {
    duration: 1,
    ease: "power2.inOut",
    y: 0,
    opacity: 1
  }, "-=0.9");
  
  ScrollTrigger.create({
    trigger: '.co-home-section-3-thumbnail-items-wrapper', start:'top bottom', end: "bottom top",
    animation: coHomeSection3Timeline
  });

  // Set the first thumbnail as active initially
  if (thumbnails.length > 0) {
    thumbnails[0].classList.add('co-active');
    
    // Show the first collection by default
    const firstCollectionId = thumbnails[0].getAttribute('data-collection-id');
    const firstCollection = document.getElementById(firstCollectionId);
    if (firstCollection) {
      firstCollection.classList.remove('co-hidden');
      firstCollection.classList.add('co-active');
    }
  }

  thumbnails.forEach(function(thumbnail) {
    thumbnail.addEventListener('click', function() {
      // Check if the clicked thumbnail is already active
      if (thumbnail.classList.contains('co-active')) {
        return; // If it's already active, do nothing
      }

      // Remove active class from all thumbnails
      thumbnails.forEach(function(th) {
        th.classList.remove('co-active');
      });
      // Add active class to clicked thumbnail
      thumbnail.classList.add('co-active');

      // Hide all collections by adding co-hidden class and removing co-active class
      collections.forEach(function(collection) {
        collection.classList.remove('co-active');
        collection.classList.add('co-hidden');
      });

      // Show the selected collection by removing co-hidden and adding co-active class
      const collectionId = thumbnail.getAttribute('data-collection-id');
      const selectedCollection = document.getElementById(collectionId);
      selectedCollection.classList.remove('co-hidden');
      selectedCollection.classList.add('co-active');

      // Animate items in the selected collection
      const items = [
        selectedCollection.querySelector('.co-home-section-3-collection-slider .is-previous-previous .co-home-section-3-collection-item-frame-1'),
        selectedCollection.querySelector('.co-home-section-3-collection-slider .is-previous .co-home-section-3-collection-item-frame-1'),
        selectedCollection.querySelector('.co-home-section-3-collection-slider .is-selected .co-home-section-3-collection-item-frame-1'),
        selectedCollection.querySelector('.co-home-section-3-collection-slider .is-next .co-home-section-3-collection-item-frame-1'),
        selectedCollection.querySelector('.co-home-section-3-collection-slider .is-next-next .co-home-section-3-collection-item-frame-1')
      ].filter(item => item !== null);

      gsap.fromTo(items, { opacity: 0, y: 0, x: 50 }, { opacity: 1, y: 0, x: 0, stagger: 0.1, duration: 1 });
    });
  });
});




// ========================================================================================================== SECTION 4 NEW
// ===================================================== GSAP
gsap.set('.co-home-section-4-new-ani-items-1', { opacity: 0, y: 30, transition: 0 });
gsap.set('.co-home-section-4-new-ani-items-2', { opacity: 0, scale: 1.05, transition: 0 });
gsap.set('.co-home-section-4-new-ani-items-3', { opacity: 0, y: 30, transition: 0 });
gsap.set('.co-home-section-4-new-ani-items-4', { opacity: 0, y: 30, transition: 0 });
let coHomeSection4NewTimeline = gsap.timeline({ paused: true });
coHomeSection4NewTimeline.to(".co-home-section-4-new-ani-items-1", {
  duration: 1,
  ease: "power2.inOut",
  y: 0,
  opacity: 1,
  stagger: 0.1
});
coHomeSection4NewTimeline.to(".co-home-section-4-new-ani-items-2", {
  duration: 1,
  ease: "power2.inOut",
  scale: 1,
  opacity: 1,
  stagger: 0.1
}, "-=1.1");
coHomeSection4NewTimeline.to(".co-home-section-4-new-ani-items-3", {
  duration: 1,
  ease: "power2.inOut",
  y: 0,
  opacity: 1,
  stagger: 0.1
}, "-=1.1");
coHomeSection4NewTimeline.to(".co-home-section-4-new-ani-items-4", {
  duration: 1,
  ease: "power2.inOut",
  y: 0,
  opacity: 1,
  stagger: 0.1
}, "-=1.1");
ScrollTrigger.create({
  trigger: '.co-home-section-4-new', start:'25% bottom', end: "bottom top",
  animation: coHomeSection4NewTimeline
});



// ========================================================================================================== SECTION 4
// ===================================================== GSAP
gsap.set('.co-home-section-4-right-image-bg img', { top: "0%", transition: 0 });
gsap.to('.co-home-section-4-right-image-bg img', {
  scrollTrigger: {
    trigger: '.co-home-section-4', start:'top bottom', end: "bottom top", scrub: 1
  },
  top: "-10%"
});
gsap.set('.co-home-section-4-left-image>div img', { top: "-10%", transition: 0 });
gsap.to('.co-home-section-4-left-image>div img', {
  scrollTrigger: {
    trigger: '.co-home-section-4', start:'top bottom', end: "bottom top", scrub: 1
  },
  top: "0%"
});
gsap.set('.co-home-section-4-left-image>div', { y: 0, transition: 0 });
gsap.to('.co-home-section-4-left-image>div', {
  scrollTrigger: {
    trigger: '.co-home-section-4', start:'top bottom', end: "bottom top", scrub: 1
  },
  y: -60
});
// gsap.set('.co-home-section-4-right-image img', { scale: 1, transition: 0 });
// gsap.to('.co-home-section-4-right-image img', {
//   scrollTrigger: {
//     trigger: '.co-home-section-4', start:'top bottom', end: "bottom top", scrub: 1
//   },
//   scale: 0.9
// });
// TIMELINE
gsap.set('.co-home-section-4-left-ani-item', { opacity: 0, y: 60, transition: 0 });
gsap.set('.co-home-section-4-right-image', { opacity: 0, scale: 1.2, transition: 0 });
let coHomeSection4LeftItemsTimeline = gsap.timeline({ paused: true });
coHomeSection4LeftItemsTimeline.to(".co-home-section-4-left-ani-item", {
  duration: 1,
  ease: "power2.inOut",
  y: 0,
  opacity: 1,
  stagger: 0.1
});
coHomeSection4LeftItemsTimeline.to(".co-home-section-4-right-image", {
  duration: 1,
  ease: "power2.inOut",
  scale: 1,
  opacity: 1
}, "-=1.1");
ScrollTrigger.create({
  trigger: '.co-home-section-4', start:'25% bottom', end: "bottom top",
  animation: coHomeSection4LeftItemsTimeline
});
// ========================================================================================================== SECTION 5
// ===================================================== GSAP
gsap.set('.co-home-section-5-column-image-frame-2', { scale: 1, transition: 0 });
gsap.to('.co-home-section-5-column-image-frame-2', {
  scrollTrigger: {
    trigger: '.co-home-section-5-column-content', start:'top bottom', end: "bottom top", scrub: 1
  },
  scale: 1.1
});
gsap.set('.co-home-section-5-ani-items-1', { opacity: 0, y: 30, transition: 0 });
gsap.set('.co-home-section-5-ani-items-2', { opacity: 0, scale: 1.05, transition: 0 });
gsap.set('.co-home-section-5-ani-items-3', { opacity: 0, y: 30, transition: 0 });
let coHomeSection5Timeline = gsap.timeline({ paused: true });
coHomeSection5Timeline.to(".co-home-section-5-ani-items-1", {
  duration: 1,
  ease: "power2.inOut",
  y: 0,
  opacity: 1,
  stagger: 0.1
});
coHomeSection5Timeline.to(".co-home-section-5-ani-items-2", {
  duration: 1,
  ease: "power2.inOut",
  scale: 1,
  opacity: 1,
  stagger: 0.1
}, "-=1.1");
coHomeSection5Timeline.to(".co-home-section-5-ani-items-3", {
  duration: 1,
  ease: "power2.inOut",
  y: 0,
  opacity: 1,
  stagger: 0.1
}, "-=1.1");
ScrollTrigger.create({
  trigger: '.co-home-section-5', start:'25% bottom', end: "bottom top",
  animation: coHomeSection5Timeline
});
// ===================================================== POPUP
document.querySelectorAll('.co-home-section-5-columns').forEach(function(column) {
  let openButton = column.querySelector('.co-home-section-5-column-button');
  let closeButton = column.querySelector('.co-home-section-5-column-close');
  let popup = column.querySelector('.co-home-section-5-column-popup');
  let body = document.querySelector('body');
  let animate = column.querySelector('.co-home-section-5-column-popup-ani');

  openButton.addEventListener('click', function(e) {
    e.preventDefault();
    if (!popup.classList.contains('co-home-section-5-column-popup-active')) {
      popup.classList.add('co-home-section-5-column-popup-active');
    }
    if (!body.classList.contains('co-body-overflow-hidden')) {
      body.classList.add('co-body-overflow-hidden');
    }
    if (!animate.classList.contains('co-home-section-5-column-popup-ani-active')) {
      setTimeout(function() {
        animate.classList.add('co-home-section-5-column-popup-ani-active');
      }, 50);
    }    
  });

  closeButton.addEventListener('click', function(e) {
    e.preventDefault();
    if (popup.classList.contains('co-home-section-5-column-popup-active')) {
      popup.classList.remove('co-home-section-5-column-popup-active');
    }
    if (body.classList.contains('co-body-overflow-hidden')) {
      body.classList.remove('co-body-overflow-hidden');
    }
    if (animate.classList.contains('co-home-section-5-column-popup-ani-active')) {
      setTimeout(function() {
        animate.classList.remove('co-home-section-5-column-popup-ani-active');
      }, 50);
    }    
  });
});


// ========================================================================================================== SECTION 6
// ===================================================== GSAP
gsap.set('.co-home-section-6-new-image-frame img', { scale: 1, transition: 0 });
gsap.to('.co-home-section-6-new-image-frame img', {
  scrollTrigger: {
    trigger: '.co-home-section-6-new', start:'top bottom', end: "bottom top", scrub: 1
  },
  scale: 1.15
});
gsap.set('.co-home-section-6-new-ani-items-1', { opacity: 0, y: 30, transition: 0 });
gsap.set('.co-home-section-6-new-ani-items-2', { opacity: 0, scale: 1.15, transition: 0 });
let coHomeSection6NewTimeline = gsap.timeline({ paused: true });
coHomeSection6NewTimeline.to(".co-home-section-6-new-ani-items-1", {
  duration: 1,
  ease: "power2.inOut",
  y: 0,
  opacity: 1,
  stagger: 0.1
});
coHomeSection6NewTimeline.to(".co-home-section-6-new-ani-items-2", {
  duration: 1,
  ease: "power2.inOut",
  scale: 1,
  opacity: 1,
  stagger: 0.1
}, "-=1.1");
ScrollTrigger.create({
  trigger: '.co-home-section-6-new', start:'25% bottom', end: "bottom top",
  animation: coHomeSection6NewTimeline
});


// ========================================================================================================== SECTION 6
// ===================================================== GSAP
const coHomeSection6Check = document.querySelector('.co-home-section-6');
if (coHomeSection6Check) {
  // TIMELINE
  gsap.set('.co-home-section-6-ani-item', { opacity: 0, y: 60, transition: 0 });
  let coHomeSection6ItemsTimeline = gsap.timeline({ paused: true });
  coHomeSection6ItemsTimeline.to(".co-home-section-6-ani-item", {
    duration: 1,
    ease: "power2.inOut",
    y: 0,
    opacity: 1,
    stagger: 0.1
  });
  ScrollTrigger.create({
    trigger: '.co-home-section-6', start:'25% bottom', end: "bottom top",
    animation: coHomeSection6ItemsTimeline
  });
}
// ========================================================================================================== SECTION 7
// ===================================================== GSAP
gsap.set('.co-home-section-7-frame', { y: 30, opacity: 0, transition: 0 });
gsap.to('.co-home-section-7-frame', {
  scrollTrigger: {
    trigger: '.co-home-section-7', start:'25% bottom', end: "bottom top"
  },
  y: 0,
  opacity: 1
});
// ===================================================== FLICKITY
new Flickity( '.co-home-section-7-slider-1', {
    fade: true, 
    prevNextButtons: false, 
    pageDots: false, 
    wrapAround: true,
    // autoPlay: 9000,
    on: {
      ready: function() {

      }
    }
  });
new Flickity( '.co-home-section-7-slider-2', {
    asNavFor: ".co-home-section-7-slider-1", 
    contain: true, 
    cellAlign: "center", 
    pageDots: false, 
    prevNextButtons: false, 
    wrapAround: true,
    draggable: false,
    on: {
      ready: function() {

      }
    }
  });
// ========================================================================================================== SECTION 8
// ===================================================== GSAP
gsap.set('.co-home-section-8-right-image-bg img', { top: "0%", transition: 0 });
gsap.to('.co-home-section-8-right-image-bg img', {
  scrollTrigger: {
    trigger: '.co-home-section-8', start:'top bottom', end: "bottom top", scrub: 1
  },
  top: "-10%"
});
gsap.set('.co-home-section-8-right-float-1 img', { y: 0, transition: 0 });
gsap.to('.co-home-section-8-right-float-1 img', {
  scrollTrigger: {
    trigger: '.co-home-section-8', start:'top bottom', end: "bottom top", scrub: 1
  },
  y: -100
});
gsap.set('.co-home-section-8-right-float-2 img', { y: 0, x: 0, transition: 0 });
gsap.to('.co-home-section-8-right-float-2 img', {
  scrollTrigger: {
    trigger: '.co-home-section-8', start:'top bottom', end: "bottom top", scrub: 1
  },
  x: -35,
  y: 80
});
gsap.set('.co-home-section-8-right-float-3 img', { y: 0, x: 0, transition: 0 });
gsap.to('.co-home-section-8-right-float-3 img', {
  scrollTrigger: {
    trigger: '.co-home-section-8', start:'top bottom', end: "bottom top", scrub: 1
  },
  x: -15,
  y: -110
});
// TIMELINE
gsap.set('.co-home-section-8-ani-item', { opacity: 0, y: 60, transition: 0 });
gsap.set('.co-home-section-8-right-image', { opacity: 0, scale: 1.2, transition: 0 });
gsap.set('.co-home-section-8-right-floats-ani>div', { opacity: 0, scale: 1.3, transition: 0 });
let coHomeSection8ItemsTimeline = gsap.timeline({ paused: true });
coHomeSection8ItemsTimeline.to(".co-home-section-8-ani-item", {
  duration: 1,
  ease: "power2.inOut",
  y: 0,
  opacity: 1,
  stagger: 0.1
});
coHomeSection8ItemsTimeline.to(".co-home-section-8-right-image", {
  duration: 1,
  ease: "power2.inOut",
  scale: 1,
  opacity: 1
}, "-=1.1");
coHomeSection8ItemsTimeline.to(".co-home-section-8-right-floats-ani>div", {
  duration: 1,
  ease: "power2.inOut",
  scale: 1,
  opacity: 1,
  stagger: 0.1
}, "-=0.9");
ScrollTrigger.create({
  trigger: '.co-home-section-8', start:'25% bottom', end: "bottom top",
  animation: coHomeSection8ItemsTimeline
});
// ========================================================================================================== SECTION 9
// ===================================================== FLICKITY
new Flickity( '.co-home-section-9-blog-slider', {
      cellAlign: "center",
      contain: true,
      prevNextButtons: true,
      pageDots: false,
      wrapAround: true,
      selectedAttraction: 0.005,
      friction: 0.15,
    on: {
      ready: function() {
        // ===================================================== GSAP
        const coHomeSection9Items = [
          document.querySelector('.co-home-section-9-blog-slider .is-previous-previous .co-home-section-9-blog-item-frame-1'),
          document.querySelector('.co-home-section-9-blog-slider .is-previous .co-home-section-9-blog-item-frame-1'),
          document.querySelector('.co-home-section-9-blog-slider .is-selected .co-home-section-9-blog-item-frame-1'),
          document.querySelector('.co-home-section-9-blog-slider .is-next .co-home-section-9-blog-item-frame-1'),
          document.querySelector('.co-home-section-9-blog-slider .is-next-next .co-home-section-9-blog-item-frame-1')
        ].filter(item => item !== null);

        gsap.set('.co-home-section-9-main-title', { opacity: 0, y: 30, transition: 0 });
        gsap.set('.co-home-section-9-blog-slider-wrapper', { opacity: 0, transition: 0 });
        gsap.set('.co-home-section-9-main-button', { opacity: 0, y: 30, transition: 0 });
        gsap.set('.co-home-section-9-main-description', { opacity: 0, y: 30, transition: 0 });
        
        let coHomeSection9Timeline = gsap.timeline({ paused: true });
        coHomeSection9Timeline.to(".co-home-section-9-blog-slider-wrapper", {
          duration: 0.3,
          opacity: 1
        });
        coHomeSection9Timeline.to(".co-home-section-9-main-title", {
          duration: 1,
          ease: "power2.inOut",
          y: 0,
          opacity: 1
        }, "-=0.3");
        coHomeSection9Timeline.fromTo(coHomeSection9Items, { opacity: 0, yPercent: 0, xPercent: 20 }, { opacity: 1, yPercent: 0, xPercent: 0, stagger: 0.1, duration: 1 }, "-=0.6");
        coHomeSection9Timeline.to(".co-home-section-9-main-button", {
          duration: 1,
          ease: "power2.inOut",
          y: 0,
          opacity: 1
        }, "-=1.1");
        coHomeSection9Timeline.to(".co-home-section-9-main-description", {
          duration: 1,
          ease: "power2.inOut",
          y: 0,
          opacity: 1
        }, "-=0.9");

        ScrollTrigger.create({
          trigger: '.co-home-section-9-blog-slider-wrapper', start:'top bottom', end: "bottom top",
          animation: coHomeSection9Timeline
        });

      }
    }
  });

